import React from 'react';

function BlockG() {
  const otherReceiptsData = [
    {
      slNo: 1,
      item: 'Receipts from manufacturing services (including work done for others on materials supplied by them and sale value of waste left by the party)',
      receipts: 0
    },
    {
      slNo: 2,
      item: 'Receipts from non-manufacturing services (including non-industrial services)',
      receipts: 0
    },
    {
      slNo: 3,
      item: 'Value of Electricity Generated and Sold.',
      receipts: 0
    },
    {
      slNo: 4,
      item: 'Value of Own Construction',
      receipts: 0
    },
    {
      slNo: 5,
      item: 'Net Balance of Goods Sold in the same condition as purchased (Item 11 ofBl.G minus item 11 of BL.F)',
      receipts: 0
    },
    {
      slNo: 6,
      item: 'Rent Received for P&M and Other Fixed Assets',
      receipts: 0
    },
    {
      slNo: 7,
      item: 'Variation in Stock of Semi-finished goods (Col. (4) minus Col.(3)against item 5 in BL.D)',
      receipts: 0
    },
    {
      slNo: 8,
      item: 'Rent Received for Buildings',
      receipts: 0
    },
    {
      slNo: 9,
      item: 'Rent Received for Land on lease or royalties on mines, quarries and similar assets',
      receipts: 0
    },
    {
      slNo: 10,
      item: 'Interest Received',
      receipts: 0
    },
    {
      slNo: 11,
      item: 'Sale Value of Goods Sold in the same condition as purchased',
      receipts: 0
    },
    {
      slNo: 12,
      item: 'Total Subsidies',
      receipts: 0
    }
  ];

  const formatNumber = (num) => {
    return num.toLocaleString();
  };

  return (
    <>
      <style>
        {`
          .block-g-header {
            background-color: #e3f2fd;
            padding: 15px 20px;
            border-bottom: 2px solid #1976d2;
            margin-bottom: 20px;
          }
          .page-title {
            color: #1976d2;
            font-size: 24px;
            font-weight: bold;
            margin: 0;
          }
          .reference-numbers {
            color: #333;
            font-size: 14px;
            font-weight: 500;
            margin: 0;
          }
          .other-receipts-table {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
          }
          .table-header {
            background-color: #f8f9fa;
            border-bottom: 2px solid #1976d2;
          }
          .table th {
            background-color: #e3f2fd;
            color: #1976d2;
            font-weight: 600;
            font-size: 14px;
            text-align: center;
            vertical-align: middle;
            padding: 12px 8px;
            border: 1px solid #dee2e6;
          }
          .table td {
            font-size: 13px;
            text-align: center;
            vertical-align: middle;
            padding: 10px 8px;
            border: 1px solid #dee2e6;
          }
          .table td:first-child {
            text-align: center;
            font-weight: 600;
            width: 80px;
          }
          .table td:nth-child(2) {
            text-align: left;
            font-weight: 500;
            min-width: 400px;
          }
          .table td:nth-child(3) {
            text-align: right;
            font-weight: 500;
            width: 150px;
          }
          .sub-item {
            color: #666;
            font-size: 12px;
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        <div className="block-g-header">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1 className="page-title">G: OTHER OUTPUT/RECEIPTS</h1>
            </div>
            <div className="col-md-6 text-end">
              <p className="reference-numbers">DSL No : 404936</p>
              <p className="reference-numbers">PSL No : 31186</p>
            </div>
          </div>
        </div>

        {/* Other Output/Receipts Table */}
        <div className="other-receipts-table">
          <div className="table-responsive">
            <table className="table table-bordered mb-0">
              <thead className="table-header">
                <tr>
                  <th>SI No</th>
                  <th>Items</th>
                  <th>Receipts (in Rs.)</th>
                </tr>
              </thead>
              <tbody>
                {otherReceiptsData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.slNo}</td>
                    <td>{row.item}</td>
                    <td>{formatNumber(row.receipts)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row mt-4">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button type="button" className="btn btn_orange mx-1">
              Print  
              <i className="fa fa-print ms-1"></i>
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Save
            </button>
            <button type="reset" className="btn btn_orange mx-1">
              Reset
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button type="button" className="btn btn_orange mx-1">
              Back 
              <i className="fa fa-angle-left ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockG; 